import React from 'react';

import component, {classnames} from './component';
import flagData from './FlagData.js';

export default component('Flag', {

  propTypes: {
    country: React.PropTypes.string,
    outputName: React.PropTypes.bool
  },

  render() {

    const country = flagData.countries[this.props.country];

    if (!country) {
      return null;
    } else {
      return (
        <div className={classnames(
           'Flag',
           `Flag--${this.props.country}`,
           {[`Flag--${country.localCode}`]: country.localCode},
           this.props.className
         )}>
          {this.props.outputName &&
          <span className='Flag-CountryName'>{country.name}</span>
          }
        </div>
      );
    }
  }

});



// WEBPACK FOOTER //
// ./src/components/Flag.js